import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Common
import CommonPagingView from "../Common/Views/PagingView";
import CommonStepperView from "../Common/Views/StepperView";
import CommonLocalStorageWidget from "Fratello/Common/Widgets/LocalStorageWidget";

ComponentRegistry.register({
    CommonPagingView, 
    CommonStepperView, 
    CommonLocalStorageWidget
});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/Common.jsx